import React, { useContext } from "react";
import "./Profile.css";
import { AuthContext } from "../../context/authContext";
import LoadingPage from "../../Error/LoadingPage/LoadingPage";
import { renderStatementWithKaTeX } from "../../Status";
const Profile = () => {
  const { user } = useContext(AuthContext);
  if (!user) {
    return <LoadingPage />;
  }

  return (
    <div className="profile-container">
      <span className="floating-symbol pi">
                        {renderStatementWithKaTeX("$\\pi$")}
                      </span>
                      <span className="floating-symbol sigma">
                        {renderStatementWithKaTeX("$\\sum$")}
                      </span>
                      <span className="floating-symbol infinity">
                        {renderStatementWithKaTeX("$\\infty$")}
                      </span>
                      <span className="floating-symbol sqrt">
                        {renderStatementWithKaTeX("$\\sqrt{}$")}
                      </span>
                      <span className="floating-symbol integral">
                        {renderStatementWithKaTeX("$\\int$")}
                      </span>
                      <span className="floating-symbol plusminus">
                        {renderStatementWithKaTeX("$\\pm$")}
                      </span>
                      <span className="floating-symbol prod">
                        {renderStatementWithKaTeX("$\\prod$")}
                      </span>
                      <span className="floating-symbol R">
                        {renderStatementWithKaTeX("$\\mathbb{R}$")}
                      </span>

      <h1>My Profile :</h1>
      <h2>(This page can only be seen by you)</h2>
      <div className="profile-card">
        <div className="profile-left-section">
          <div className="profile-header">
            <h2>{user.username}</h2>
            <span className={`role-badge ${user.role.toLowerCase()}`}>
              {user.role}
            </span>
          </div>

          <p className="email">{user.email}</p>
          <p className="nationality">
            🌍 <b>Nationality:</b> {user.nationality}
          </p>
          <p className="class">
            🎓 <b>Class of:</b> {user.ClassOf}
          </p>
          <p className="points">
            ⭐ <b>Points:</b> {user.studentData?.points}
          </p>

          <div className="scores">
  <h3>Scores</h3>
  <ul>
    {Object.entries(user.studentData?.score || {}).map(([subject, value]) => (
      <li key={subject}>
        <div className="score-label">
          {subject}: {value}
        </div>
        <div className="score-bar">
          <div
            className="score-fill"
            style={{
              width: `${value}%`,
              backgroundColor:
                value >= 75
                  ? "#16a34a" // green for high score
                  : value >= 40
                  ? "#f59e0b" // orange for medium
                  : "#ef4444", // red for low
            }}
          ></div>
        </div>
      </li>
    ))}
  </ul>
</div>

        </div>
        <div className="profile-right-section">
          <div className="badges">
            <h3>
              Solved Problems : {user.studentData?.problemsSolved?.length}
            </h3>
            {user.studentData?.problemsSolved?.length > 0 ? (
              <ul>
                {user.studentData.problemsSolved.map((problem, index) => (
                  <li key={index}>{problem}</li>
                ))}
              </ul>
            ) : (
              <p>No problem solved yet</p>
            )}
          </div>
          <div className="badges">
            <h3>Badges : {user.studentData?.Badges?.length}</h3>
            {user.studentData?.Badges?.length > 0 ? (
              <ul>
                {user.studentData.problemsSolved.map((badge, index) => (
                  <li key={index} style={{ background: badge.color , color : "white" }}>
                    {badge.Title}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No problem solved yet</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;

/* import {React, useState} from "react";
import "./Profile.css";
import CircularProgress from "./CircularProgress/CircularProgress";
import ActiveStreak from '../Images/ActiveStreak1.png'
import InactiveStreak from '../Images/InactiveStreak.png'
const Profile = () => {
  const [Streak, setStreak] = useState(10)

  const contests=[
    { Title: 'Winter Olympiad', Date: '24/01/2026', Award: 'GM' , Link : '#'},
    { Title: 'Spring Challenge', Date: '15/03/2026', Award: 'SM' , Link : '#'},
    { Title: 'Math Mastery Cup', Date: '10/05/2026', Award: 'BM' , Link : '#'},
    { Title: 'Summer Olympiad', Date: '01/07/2026', Award: 'GM' , Link : '#'},
    { Title: 'Combinatorics Clash', Date: '21/08/2026', Award: 'HM' , Link : '#'},
    { Title: 'Autumn Invitational', Date: '30/09/2026', Award: 'SM' , Link : '#'},
    { Title: 'NT Genius Tournament', Date: '14/10/2026', Award: 'GM' , Link : '#'},
    { Title: 'Algebra Arena', Date: '22/11/2026', Award: 'BM' , Link : '#'},
    { Title: 'Geometry Grand Prix', Date: '05/12/2026', Award: '--' , Link : '#'},
    { Title: 'New Year Sprint', Date: '02/01/2027', Award: '--' , Link : '#'},
  ]

  const Honors = [
  { Honor: 'Mathematician of June 25', color: '#ff6b6b' },
  { Honor: 'NT Master of July 1', color: '#ffa502' },
  { Honor: 'Geometry Genius – July 5', color: '#1e90ff' },
  { Honor: 'Problem Solver of the Week', color: '#2ed573' },
  { Honor: 'Algebra Ace – July 10', color: '#a29bfe' },
  { Honor: 'Combinatorics King – July 12', color: '#00cec9' },
  { Honor: 'Weekly Winner – July 15', color: '#ff9f43' },
  { Honor: 'Mathematician of July 18', color: '#d63031' },
  { Honor: 'Leaderboard Topper – July 20', color: '#6c5ce7' },
  { Honor: 'Streak Keeper – July 22', color: '#fd79a8' },
  { Honor: 'Late Night Solver – July 23', color: '#2f3542' },
  { Honor: 'Speed Coder – July 24', color: '#00a8ff' },
  { Honor: 'Creative Thinker – July 25', color: '#ff7f50' },
    { Honor: 'Creative Thinker – July 25', color: '#ff7f50' },
      { Honor: 'Creative Thinker – July 25', color: '#ff7f50' },
        { Honor: 'Creative Thinker – July 25', color: '#ff7f50' },
];
  return (
    <div className="Profile-conatiner">
      <div className="Profile">
        <h1>Account Settings :</h1>
        <p>Edit your profile the way you want </p>
        <div className="Profile-Info">
          <div className="Profile-Info-Parts">
            <div className="Profile-Info-and-Daily-Streak">
              <div className="Profile-Info-Display">
                <div className="Profile-Info-Part"><label htmlFor="">Name :</label><span>write over hear</span></div>
                <div className="Profile-Info-Part"><label htmlFor="">Status :</label><span>write over hear</span></div>
                <div className="Profile-Info-Part"><label htmlFor="">From :</label><span>write over hear</span></div>
                <div className="Profile-Info-Part"><label htmlFor="">Joined :</label><span>write over hear</span></div>
                <div className="Profile-Info-Part"><label htmlFor="">Class of :</label><span>write over hear</span></div>
                <div className="Profile-Info-Part"><label htmlFor="">Intrests :</label><span>write over hear</span></div>
              </div>
              <div className="Daily-Streak">
                <span style={{color : Streak===0?'grey':'#FF4500'}}>Daily Problems</span>
                <img src={Streak===0?InactiveStreak:ActiveStreak} alt="" />
                <p style={{color : Streak===0?'grey':'#ff4400a0'}}>{Streak===0?'No streak' : `${Streak} day-streak`}</p>
              </div>
            </div>
            
              
              <div className="Score-details">
                <div className="Score-Rank">
                  <div className="Score">
                    <h2>Score</h2>
                    <h3>2400</h3>
                  </div>
                  <div className="Rank">
                    <h2>Rank</h2>
                    <h3>15 th</h3>
                  </div>
                </div>
                <div className="Detailed-Scores">
                  <CircularProgress theme={'Alg.'} current={70} total={100}/>
                  <CircularProgress theme={'Comb.'} current={70} total={100}/>
                  <CircularProgress theme={'Geo.'} current={70} total={100}/>
                  <CircularProgress theme={'NT.'} current={70} total={100}/>
                </div>
              </div>
          </div>
          <div className="Profile-Honors">
              <h3>Took Part In The Following Contests :</h3>
              <div className="Contests">
                {contests.map((el)=>(
                  <div className="Contest">
                    <a href={el.Link}>{el.Title}</a>
                    <p>{el.Date}</p>
                    <p>{el.Award}</p>
                  </div>
                ))}
              </div>
              <h3>Earned The Following Honors :</h3>
              <div className="Honors">
                {Honors.map((el)=>(
                  <div className="Honor">
                    <span style={{ backgroundColor: el.color }}>{el.Honor}</span>
                  </div>
                ))}
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
 */
